/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_RemovedInputs */

const en_us2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goal removed`)
};

const pt_br2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta removida`)
};

const es_419_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meta quitada`)
};

const pt_pt2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objetivo removido`)
};

const fr_fr2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objectif retiré`)
};

const de_de2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel entfernt`)
};

const it_it2_exercise_personal_goal_removed = /** @type {(inputs: Exercise_Personal_Goal_RemovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obiettivo rimosso`)
};

/**
* | output |
* | --- |
* | "Goal removed" |
*
* @param {Exercise_Personal_Goal_RemovedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_removed = /** @type {((inputs?: Exercise_Personal_Goal_RemovedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_RemovedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_removed(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_removed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_removed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_removed(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_removed(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_removed(inputs)
	return en_us2_exercise_personal_goal_removed(inputs)
});
export { exercise_personal_goal_removed as "exercise-personal.goal_removed" }